import { render, staticRenderFns } from "./singleCardUseRecord.vue?vue&type=template&id=2c3910b6&scoped=true"
import script from "./singleCardUseRecord.vue?vue&type=script&lang=ts"
export * from "./singleCardUseRecord.vue?vue&type=script&lang=ts"
import style0 from "./singleCardUseRecord.vue?vue&type=style&index=0&id=2c3910b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3910b6",
  null
  
)

export default component.exports